/**
 * Filter and read XML files chosen via a folder / multi-file picker.
 */
function isXmlFile(file) {
  if (!file?.name) return false;
  const name = file.name.toLowerCase();
  if (name.endsWith(".xml")) return true;

  const type = String(file.type || "").toLowerCase();
  return type === "text/xml" || type === "application/xml";
}

export function filterXmlFiles(fileList) {
  return Array.from(fileList || [])
    .filter(isXmlFile)
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}

export async function readXmlFiles(fileList, onProgress) {
  const xmlFiles = filterXmlFiles(fileList);

  if (xmlFiles.length === 0) {
    throw new Error("No .xml files found in the selected folder.");
  }

  const files = [];

  for (let index = 0; index < xmlFiles.length; index++) {
    const file = xmlFiles[index];
    onProgress?.({
      phase: "reading",
      message: `Reading file ${index + 1} of ${xmlFiles.length}...`,
      current: index + 1,
      total: xmlFiles.length,
    });

    const value = await file.text();
    files.push({
      fileName: file.name,
      relativePath: file.webkitRelativePath || file.name,
      value,
    });
  }

  return files;
}
